export const DOCUMENT_ORIGIN = {
    MANUAL: "Manual",
    AUTO: "Auto"
}

export const TYPE = {
    LETTER: "Letter",
    FAX: "Fax"
}

export const DOCUMENT_TYPE_MAPPING = [
    {
        documentTypeId: 14,
        documentType: 'ITD/Denial Notification',
        documentDisplayName: 'Denial Notification',
        documentTypeCode: 'DenialNotification'
    },
    {
        documentTypeId: 1,
        documentType: 'Authorization',
        documentDisplayName: 'Authorization Fax',
        documentTypeCode: 'Authorization'
    },
    {
        documentTypeId: 2,
        documentType: 'AdditionalInformation',
        documentDisplayName: 'Additional Information Fax',
        documentTypeCode: 'AdditionalInformation'
    }
];

export const ChooseActionInfoMessage = 'Select <b>Upload Additional Documents</b> to only add relevant documents to the authorization. A request for additional days of care will not be created and reviewed.';
export const AdditionalDaysRequestPendingSL = 'You cannot request additional days of care until the pending service line in this authorization is approved or denied';
export const ContinuedStayRequestTwoMoreDaysSL = 'You can submit a continued stay request no earlier than 2 days before the last approved day of post-acute care.';
export const SomethingWentWrong = 'Something went wrong. Please try again or contact Carelon support';
//Temporary array created for PAC MA Document builder migration activity .
export const PacmaDocuments = ["AdditionalInformation", "Authorization", "DenialNotification", "FacilityDenialNotification", "NOMNC", "MemberOnlyNOMNCfax", "ProviderDenialContracted", "ProviderDenialNonContracted"];
export const RequestAdditionalInfoMesage = 'Based on the clinical review of the documents currently submitted, the request for SNF services is at risk of either being denied or receiving a NOMNC. If available, new, or additional information to support medical necessity can be submitted before the request is finalized. You may upload the information via the Carelon Medical Benefits Management portal or send it via fax. If fax, include the member ID, authorization number, and "additional information" on the cover sheet. {FAX_NUMBER}\n\nPlease be sure you are not submitting duplicate information to the authorization as this may delay the decision. If you have already provided all documentation available for the member, then no further action is needed.';
export const AnthemFax = '833-311-2986';
export const RegenceFax = '833-623-3037';
export const BCBSRIFax = '833-623-3039';
export const NextBlueFax = '877-313-1086';
export const WellMarkAdvantageFax = '866-460-0174';
export const WyoBlueAdvantageFax = '888-271-9728';
export const ServiceFacility = 'Service Facility';
export const ReferralFacility = 'Referral Provider';